import BaseModel from './base-model';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';


class AnimationBaseModel extends BaseModel {
    constructor(props?) {
        super(props);
        this.type = UIModelType.ANIMATION;
    }

    public unbindSDK(): void {
        super.unbindSDK();
        if (this.selected) {
            this.getSelectedAnims()?.remove(this);
        }
    }
    /**
     * 监听sdk变更
     * @protected
     */
    protected addObserverTarget(): void {
        // 仅2.0需监听变更，3.0 sdkData不存在subscribe方法，无需处理
    }
}

export default AnimationBaseModel;
